import { MapCoordinate, MapMarker } from "@app/interface/Theme";
import * as React from "react";

import config from "@app/config";

type Props = {
  center?: MapCoordinate;
  startingCoordinates?: MapMarker;
  markers?: MapMarker[];
  paddingBottom?: string;
  relative?: boolean;
};

const StoreMap: React.FC<Props> = ({
  center = { latitude: null, longitude: null },
  startingCoordinates = { latitude: -37.8136, longitude: 144.9631 },
  markers = [],
}) => {
  const mapContainer = React.useRef<HTMLDivElement | null>(null);
  const map = React.useRef<any | null>(null);

  React.useEffect(() => {
    if (typeof window !== "undefined" && window.mapboxgl) {
      window.mapboxgl.accessToken = config.mapbox.accessToken;
    }
    if (!map.current && mapContainer.current && window.mapboxgl) {
      map.current = new window.mapboxgl.Map({
        container: mapContainer.current,
        style: "mapbox://styles/mapbox/light-v11",
        center: [startingCoordinates.longitude, startingCoordinates.latitude],
        zoom: 5,
      });
      map.current?.once?.("load", () => {
        map.current?.resize();
      });

      markers.forEach((marker: MapMarker, index: number) => {
        if (map.current) {
          const el = document.createElement("div");
          el.className = `mapBoxmarker mapBoxmarker_${index}`;
          new mapboxgl.Marker(el)
            .setLngLat([marker.longitude, marker.latitude]) // Marker coordinates
            .addTo(map.current);
        }
      });
    }
  }, [markers, startingCoordinates.latitude, startingCoordinates.longitude]);

  React.useEffect(() => {
    if (center.latitude && center.longitude) {
      map.current?.setCenter([center.longitude, center.latitude]);

      map.current?._markers?.forEach((marker: any) => {
        marker._element.classList.remove("mapBoxmarker_active");
        if (
          marker._lngLat.lat.toFixed(2) === center.latitude.toFixed(2) &&
          marker._lngLat.lng.toFixed(2) === center.longitude.toFixed(2)
        ) {
          marker._element.classList.add("mapBoxmarker_active");
        }
      });
    }
  }, [center]);

  return (
    <div className="store-map">
      <div className="store-map__map" ref={mapContainer} />
    </div>
  );
};
export default StoreMap;
